export const getTypeOfPolicy = (productType) => {
  if (productType?.toUpperCase()?.slice(0, 1) === "A") {
    return "annuity";
  } else return "lifeTerm";
};
